{
  "EMOJI": {
    "PLACEHOLDER": "Søg emojis",
    "NOT_FOUND": "Ingen emoji matcher din søgning",
    "REMOVE": "Fjern"
  }
}
